export default __webpack_public_path__ + "static/media/AnimalsWhite_07.9a93ee07.png";